<template>
  <main>
    <main-img></main-img>
    <main-diff></main-diff>
    <main-management></main-management>
    <main-partner></main-partner>
    <main-interface></main-interface>
    <main-client></main-client>
    <main-help></main-help>
  </main>
</template>
<script>
import mainImg from "@/components/test/mainContent.vue";
import mainDiff from "@/components/test/mainDifference.vue";
import mainManagement from "@/components/test/mainManagement.vue";
import mainInterface from "@/components/test/mainInterface.vue";
import mainPartner from "@/components/test/mainPartner.vue";
import mainClient from "@/components/test/mainClient.vue";
import mainHelp from "@/components/test/mainHelp.vue";

export default {
  components: {
    mainImg,
    mainDiff,
    mainManagement,
    mainInterface,
    mainPartner,
    mainClient,
    mainHelp,
  },
};
</script>
